import { render, staticRenderFns } from "./DashboardPengendalian.vue?vue&type=template&id=6c7a4798&scoped=true&"
import script from "./DashboardPengendalian.vue?vue&type=script&lang=js&"
export * from "./DashboardPengendalian.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./DashboardPengendalian.vue?vue&type=style&index=1&id=6c7a4798&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a4798",
  null
  
)

export default component.exports